import React, { useState } from "react";

import "./QuizMenu.scss";

type PropsType = {
  questions: any[];
  answeredList: any[];
  handleBoxClick: Function;
  handleModalToggle: Function;
};

export default function QuizMenu(props: PropsType) {
  const { questions, answeredList, handleBoxClick: handleMainBoxClick, handleModalToggle } = props;

  let totalCorrectAnswer = 0;
  let totalIncorrectAnswer = 0;
  let totalUnattempted = 0;

  const handleBoxClick = (index, { selected }) => {
    if (selected) {
      handleMainBoxClick(index);
      handleModalToggle(false);
    } else {
    }
  };

  const countQuestionsAnswered = () => {
    questions.forEach((question) => {
      let foundAnswerflag = false;
      answeredList.forEach((answeredItem) => {
        if (answeredItem.questionId === question.id) {
          foundAnswerflag = true;
          if (answeredItem.flag) {
            totalCorrectAnswer += 1;
          } else {
            totalIncorrectAnswer += 1;
          }
        }
      });

      if (!foundAnswerflag) {
        totalUnattempted += 1;
      }
    });
  };
  countQuestionsAnswered();

  const renderBox = (answerStatus, index) => {
    switch (answerStatus) {
      case "correct":
        return (
          <div key={index} className="box correct" onClick={() => handleBoxClick(index, { selected: true })}>
            {index + 1}
          </div>
        );
      case "incorrect":
        return (
          <div key={index} className="box incorrect" onClick={() => handleBoxClick(index, { selected: true })}>
            {index + 1}
          </div>
        );
      case "notAttempted":
        return (
          <div key={index} className="box not_attempted" onClick={() => handleBoxClick(index, { selected: false })}>
            {index + 1}
          </div>
        );
      default:
        return "";
    }
  };

  const renderQuestionBoxes = () => {
    return questions.map((question, index) => {
      if (answeredList.length) {
        let isContain = false;
        let answeredBox = answeredList.map((answeredQuestion) => {
          if (question.id === answeredQuestion.questionId) {
            isContain = true;
            if (answeredQuestion.flag) {
              return renderBox("correct", index);
            } else {
              return renderBox("incorrect", index);
            }
          }
        });
        if (!isContain) {
          return renderBox("notAttempted", index);
        } else {
          return answeredBox;
        }
      } else {
        return renderBox("notAttempted", index);
      }
    });
  };
  return (
    <div className="quiz_menu">
      <div className="menu_header">
        <p>Blockchain topic</p>
        <div className="quiz_info_container">
          <div className="info_tab correct_tab">
            <p>{totalCorrectAnswer}</p>
            <label>Correct</label>
          </div>
          <div className="info_tab attempted_tab">
            <p>{totalUnattempted}</p>
            <label>Unattempted</label>
          </div>
          <div className="info_tab incorrect_tab">
            <p>{totalIncorrectAnswer}</p>
            <label>Incorrect</label>
          </div>
          {/* <div className="info_tab missed_tab">
            <p>00</p>
            <label>Missed</label>
          </div> */}
        </div>
      </div>
      <div className="menu_body not_selectable">{renderQuestionBoxes()}</div>
    </div>
  );
}
